<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQueryCus">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory']" >
              <a-select showSearch optionFilterProp="children" v-model="queryParam.factoryId" :options="factoryOptions" :placeholder="language['column.pleaseChoose'] + language['factory']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['legalperson']">
              <a-select showSearch optionFilterProp="children" v-model="queryParam.legalpersonId" :options="legalpersonOptions" :placeholder="language['column.pleaseChoose'] + language['legalperson']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          
          <template v-if="toggleSearchStatus">
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['businessGroupName']">
                <a-select  :placeholder="language['column.pleaseChoose'] + language['businessGroupName']"  v-model="queryParam.businessGroupId"
                                  :options="businessGroupOptions"
                                  @change="handleGroupVal" allowClear>
                </a-select >
               </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['businessUnitName']">
                <a-select
                  :placeholder="language['column.pleaseChoose'] + language['businessUnitName']"
                  v-model="queryParam.businessUnitId"
                  :options="businessUnitOptions"
                  allowClear>
                </a-select>
               </a-form-item>
            </a-col>
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['dangerLevel']">
                <j-dict-select-tag :placeholder="language['column.pleaseChoose'] + language['dangerLevel']" v-model="queryParam.dangerLevel" dictCode="ep_danger_level" allowClear/>
              </a-form-item>
            </a-col>
            
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item :label="language['inspectTime']">
                <j-date :placeholder="language['common.chooseStartDate']" class="query-group-cust" v-model="queryParam.startTime"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date :placeholder="language['common.chooseEndDate']" class="query-group-cust" v-model="queryParam.endTime"></j-date>
              </a-form-item>
            </a-col>
            
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQueryCus" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchResetCus" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>

        <a-row>
          <a-button type="primary" icon="download" @click="handleExportXls(language['danger.state.table'] )" style="margin-left: 8px">{{language['common.exportButton']}}</a-button>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-button @click="handlerUpdate('1')" type="primary" :disabled="disabledState">复查维护</a-button>
      <a-button @click="handlerUpdate('2')" type="primary" :disabled="disabledState">申请延期</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div> -->

    <!-- table区域-begin -->
    <a-tabs>
      <a-tab-pane key="1" :tab="language['list.info.title']">
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}}
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
            <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
          </div>

          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :pagination="false"
            class="j-table-force-nowrap"
            :scroll="{x:true}"
            :columns="columns"
            :dataSource="dataSource"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            @change="handleTableChange">

            <!-- <span slot="dangerState" slot-scope="text, record">
              <span v-if="record.correctiveFlag ==0">未整改</span>
              <span v-else>已整改</span>
            </span> -->

            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>

              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="handleDetail(record)">详情</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>

          </a-table>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" :tab="language['histogram']">
        <div style="overflow-x: scroll;">
          <bar :dataSource="this.barDataSource" width="2200" />
        </div>
      </a-tab-pane>

    </a-tabs>

    <!-- <ep-danger-check-modal ref="modalForm" @ok="modalFormOk"/> -->
  </a-card>
</template>

<script>
  import { getAction, postAction,downFile } from '@/api/manage'
   import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  // import EpDangerCheckModal from './modules/EpDangerCheckModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import Pie from '@/components/chart/Pie'
  import Bar from '@/components/chart/Bar'

const scale = [{
  dataKey: 'value',
  alias: '个'
}];

const label = {
  textStyle: {
    fill: '#aaaaaa'
  }
}

const title = {
  offset: 80
}

const tickLine = {
  alignWithLabel: false,
  length: 0
}

const labelformat = {
  textStyle: {
    fill: '#aaaaaa'
  },
  formatter: function formatter(text) {
    return text.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  }
}
const color = ['type', ['#40a9ff', '#1890ff', '#096dd9', '#0050b3']];

 
  export default {
    name: "EpDangerCheckList",
  //  mixins:[JeecgListMixin],
    components: {
      Pie,Bar
    },
    data () {
      return {
        data: [],
        scale,
        label,
        tickLine,
        title,
        labelformat,
        color,
        description: '隐患程度分析表',
        /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      /* 数据源 */
      dataSource:[],
      // 表格缓存的数据 - 用来点击取消时回显数据
      cacheData: [],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 1000,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading:false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus:true,  //true 默认展开
         url: {
          list: "/epm/report/getDangerStateReport",

         // list: "/epm/report/getDangerLevelReport",
          exportXlsUrl: "/epm/report/exportXlsDangerState",
          queryFactoryList: '/sys/epFactory/list',
          queryLegalpersonList: '/sys/epPerson/list',
          queryBusinessGroupList: "/sys/sysDepart/queryBusinessGroupList",
          queryBusinessUnitList: "/sys/sysDepart/queryBusinessUnitList"
        },
        dictOptions:{},
        superFieldList:[],
        factoryOptions: [],
        legalpersonOptions:[],
        disabledState:true,
        id:'',

        newDataSource:[],
        pieDataSource:[],
        barDataSource:[],
        businessGroupOptions:[],
        businessUnitOptions:[]

      }
    },
    created() {
      this.initBusinessGroupList();
      this.initQueryDate();
      this.searchQueryCus(1);
      this.initfactoryList();
      this.initlegalpersonList();

    },

    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['factory'],
              align:"center",
              // sorter: true,
              dataIndex: 'factoryName',

            },
            {
              title:this.language['legalperson'],
              align:"center",
              // sorter: true,
              dataIndex: 'personName',
              // scopedSlots: { customRender: 'dangerState' },
            },
            {
              title:this.language['businessGroupName'],
              align:"center",
              // sorter: true,
              dataIndex: 'businessGroupName'
            },

            {
              title:this.language['businessUnitName'],
              align:"center",
              // sorter: true,
              dataIndex: 'businessUnitName'
            },
            {
              title:this.language['common.save'],
              align:"center",
              dataIndex: 'saveState'
            },
            {
              title:this.language['signingState'],
              align:"center",
              // sorter: true,
              dataIndex: 'signingState'
            },
            {
              title:this.language['signedState'],
              align:"center",
              // sorter: true,
              dataIndex: 'signedState'
            },
            {
              title:this.language['deferSignState'],
              align:"center",
              // sorter: true,
              dataIndex: 'deferSignState'
            },
            {
              title:this.language['deferConfirmState'],
              align:"center",
              // sorter: true,
              dataIndex: 'deferConfirmState'
            },
            {
              title:this.language['rectifyedState'],
              align:"center",
              // sorter: true,
              dataIndex: 'rectifyedState'
            },
            {
              title:this.language['archivePassState'],
              align:"center",
              // sorter: true,
              dataIndex: 'archivePassState'
            },
            {
              title:this.language['archiveCancelState'],
              align:"center",
              // sorter: true,
              dataIndex: 'archiveCancelState'
            },
            {
              title:this.language['totalSum'],
              align:"center",
              dataIndex: 'stateSum'
            }
          ]
        }
      }
    },
    methods: {
      initQueryDate(){
        this.queryParam = {startTime: this.getOneMonthDate(),endTime: this.getNowDate()}
      },
      getNowDate()
      {
        let month =parseInt(new Date().getMonth())+1;
        return new Date().getFullYear()+"/"+month+"/"+new Date().getDate();
      },
      getOneMonthDate()
      {
        const dates = new Date()
        dates.setMonth(dates.getMonth() - 1)
        let pastMonth = dates.getMonth() + 1
        let pastDay = dates.getDate()
        if (pastMonth >= 1 && pastMonth <= 9) {
          pastMonth = '0' + pastMonth
        }
        if (pastDay >= 0 && pastDay <= 9) {
          pastDay = '0' + pastDay
        }
        const endDate = dates.getFullYear() + '-' + pastMonth + '-' + pastDay
        return endDate
        //return new Date().getFullYear()+"/"+new Date().getMonth()+"/"+new Date().getDate();
      },

      searchQueryCus(arg){
        console.log('1111');
        if(!this.url.list){
        this.$message.error("请设置url.list属性!")
        return
      }

      var params = this.getQueryParams();//查询条件
      this.loading = true;
      postAction(this.url.list, params).then((res) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          const result = res.result.records || res.result
          this.dataSource = result.map((v, i)=>{
            v.key = i + 1;
            return v;
          }) || res.result;
          // this.cacheData = JSON.parse(JSON.stringify(res.result.records));

          if(res.result.total)
          {
            this.ipagination.total = res.result.total;
          }else{
            this.ipagination.total = 0;
          }

          console.log('this.data==>',this.dataSource);
          //判断是否是稽查人或被稽查人
         // this.dealPieDate(this.dataSource)
         this.barDataSource = []
         this.dealBarData(this.dataSource)


        }else{
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
      },

      //饼状图数据
      dealPieDate(data) {
        for (var index in data) {

          let obj = data[index]

          let item1 = {item:'已核准', count: obj.signedState};
          let item2 = {item:'延期签核中', count: obj.deferSignState};
          let item3 = {item:'延期确认', count: obj.deferConfirmState};
          let item4 = {item:'已整改', count: obj.rectifyedState};
          let item5 = {item:'归档(复查通过)', count: obj.archivePassState};


          this.pieDataSource.push(item1)
          this.pieDataSource.push(item2)
          this.pieDataSource.push(item3)
          this.pieDataSource.push(item4)
          this.pieDataSource.push(item5)
        }
      },
      //柱状图数据
      dealBarData(data) {
        for (var index in data) {
          let obj = data[index]

          if (obj.businessUnitName != '合计') {
          //  let name_ = obj.factoryName+','+obj.personName+','+obj.businessGroupName+','+obj.businessUnitName;
            let name_ = '\n\n\n\n' + obj.factoryName+',\n'+obj.personName+',\n'+obj.businessGroupName+',\n'+obj.businessUnitName;
            this.barDataSource.push({name: name_, type:this.language['common.save'], value: obj.saveState})
            this.barDataSource.push({name: name_, type:this.language['signingState'], value: obj.signingState})
            this.barDataSource.push({name: name_, type:this.language['signedState'], value: obj.signedState})
            this.barDataSource.push({name: name_, type:this.language['deferSignState'], value: obj.deferSignState})
            this.barDataSource.push({name: name_, type:this.language['deferConfirmState'], value: obj.deferConfirmState})
            this.barDataSource.push({name: name_, type:this.language['rectifyedState'], value: obj.rectifyedState})
            this.barDataSource.push({name: name_, type:this.language['archivePassState'], value: obj.archivePassState})
            this.barDataSource.push({name: name_, type:this.language['archiveCancelState'], value: obj.archiveCancelState})
          }
        }
      },

      getQueryParams() {
      //获取查询条件
      let sqp = {}
      if(this.superQueryParams){
        sqp['superQueryParams']=encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.field = this.getQueryField();
        //稽查标识
      param.inspectFlag =1;
      return filterObj(param);
     },

     getQueryField() {
      //TODO 字段权限控制
      var str = "id,";
      this.columns.forEach(function (value) {
        str += "," + value.dataIndex;
      });
      return str;
    },

    loadDataSuccess() {
      console.log(this.dataSource)
    },

      initBusinessGroupList(){
        getAction(this.url.queryBusinessGroupList,{applicationCode:'env_audit'}).then(res=>{
          if(res.success){
            this.businessGroupOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.departName, value: item.id+""}
              return c;
            })
            console.log('this.businessGroupOptions: ',this.businessGroupOptions)
          }
        })
      },

      handleGroupVal(val){
        getAction(this.url.queryBusinessUnitList,{id:val}).then(res=>{
          if(res.success){
            this.businessUnitOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.departName, value: item.id+""}
              return c;
            })

          }
        })
      },

    searchResetCus() {
      this.queryParam = {}
      this.searchQueryCus(1);
    },

    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },

      handleExportXls(fileName){
        if(!fileName || typeof fileName != "string"){
          fileName = "导出文件"
        }
        let param = this.getQueryParams();
        if(this.selectedRowKeys && this.selectedRowKeys.length>0){
          param['selections'] = this.selectedRowKeys.join(",")
        }
        console.log("导出参数",param)
        downFile(this.url.exportXlsUrl,param).then((data)=>{
          if (!data) {
            this.$message.warning("文件下载失败")
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },

      handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      console.log(pagination)
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }

      this.searchQueryCus();
    },

      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        this.id = this.selectionRows[0].id;
        this.disabledState = this.selectionRows.length !== 1
      },

      /* handlerUpdate(key){
        this.$refs.modalForm.key = key;
        this.$refs.modalForm.id = this.id
        this.$refs.modalForm.add();
        this.$refs.modalForm.title = "整改维护";
        this.$refs.modalForm.disableSubmit = false;
      }, */

      //初始化厂区字典
      initfactoryList(){
		  let para={pageNo:1,pageSize:1000};
        getAction(this.url.queryFactoryList,para).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.factoryName, value: item.id+""}
              return c;
            })
            console.log('this.factoryOptions: ',this.factoryOptions)
          }
        })
      },

      //初始化法人字典
      initlegalpersonList(){
		  let para = {pageNo:1,pageSize:10000};
        getAction(this.url.queryLegalpersonList,para).then(res=>{
          if(res.success){
            this.legalpersonOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.legalpersonName, value: item.id+""}
              return c;
            })
            console.log('this.legalpersonOptions: ',this.legalpersonOptions)
          }
        })
      },

      backDepartInfo(info) {
        this.model.departIds = this.model.selecteddeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },
      initDictConfig(){
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  /deep/ .g2-tooltip{
      width: 200px !important;
    }
  
</style>